
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { CraftSupply } from "./types";

interface SupplyItemProps {
  supply: CraftSupply;
  onToggle: (id: string) => void;
  onRemove: (id: string) => void;
  isDefaultSupply: boolean;
}

const SupplyItem: React.FC<SupplyItemProps> = ({ 
  supply, 
  onToggle, 
  onRemove,
  isDefaultSupply
}) => {
  return (
    <div className="flex items-center justify-between space-x-2">
      <div className="flex items-center space-x-2">
        <Checkbox 
          id={`supply-${supply.id}`} 
          checked={supply.checked}
          onCheckedChange={() => onToggle(supply.id)}
        />
        <Label 
          htmlFor={`supply-${supply.id}`}
          className="cursor-pointer"
        >
          {supply.name}
        </Label>
      </div>
      {!isDefaultSupply && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onRemove(supply.id)}
          className="h-8 w-8 p-0"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default SupplyItem;
